import { render, staticRenderFns } from "./work.vue?vue&type=template&id=5aaab50b&scoped=true&"
import script from "./work.vue?vue&type=script&lang=ts&"
export * from "./work.vue?vue&type=script&lang=ts&"
import style0 from "./work.vue?vue&type=style&index=0&id=5aaab50b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aaab50b",
  null
  
)

export default component.exports